export const editorToneOptions = {
  urls: {
    C1: 'Guitar-Sample-01.mp3',
    D1: 'Guitar-Sample-02.mp3',
    E1: 'Guitar-Sample-03.mp3',
    F1: 'Guitar-Sample-04.mp3',
    G1: 'Guitar-Sample-05.mp3',
    A1: 'Guitar-Sample-06.mp3',
    B1: 'Guitar-Sample-07.mp3',
    C2: 'Guitar-Sample-08.mp3',
    D2: 'Guitar-Sample-09.mp3',
    E2: 'Guitar-Sample-10.mp3',
    F2: 'Guitar-Sample-11.mp3',
    G2: 'Guitar-Sample-12.mp3',
    A2: 'Guitar-Sample-13.mp3',
    B2: 'Guitar-Sample-14.mp3',
    C3: 'Guitar-Sample-15.mp3',
    D3: 'Guitar-Sample-16.mp3',
    E3: 'Guitar-Sample-17.mp3',
    F3: 'Guitar-Sample-18.mp3',
    G3: 'Guitar-Sample-19.mp3',
    A3: 'Guitar-Sample-20.mp3',
    B3: 'Guitar-Sample-21.mp3',
    C4: 'Guitar-Sample-22.mp3',
    D4: 'Guitar-Sample-23.mp3',
    E4: 'Guitar-Sample-24.mp3',
    F4: 'Guitar-Sample-25.mp3',
    G4: 'Guitar-Sample-26.mp3',
    A4: 'Guitar-Sample-27.mp3',
    B4: 'Guitar-Sample-28.mp3',
    C5: 'Guitar-Sample-29.mp3',
    D5: 'Guitar-Sample-30.mp3',
    E5: 'Guitar-Sample-31.mp3',
    F5: 'Guitar-Sample-32.mp3',
    G5: 'Guitar-Sample-33.mp3',
    A5: 'Guitar-Sample-34.mp3',
    B5: 'Guitar-Sample-35.mp3',
    C6: 'Guitar-Sample-36.mp3',
    D6: 'Guitar-Sample-37.mp3',
    E6: 'Guitar-Sample-38.mp3',
    F6: 'Guitar-Sample-39.mp3',
    G6: 'Guitar-Sample-40.mp3',
    A6: 'Guitar-Sample-41.mp3',
    B6: 'Guitar-Sample-42.mp3',
    C7: 'Guitar-Sample-43.mp3',
    D7: 'Guitar-Sample-44.mp3',
    E7: 'Guitar-Sample-45.mp3'
  },
  release: 1,
  baseUrl: 'https://campfire-mode.freecodecamp.org/mariachi/'
};
